import { Message } from 'element-ui';
/**
 * @description 复制内容到粘贴板
 * @param {*} txt 待复制内容值
 */
export const copyToClip = (txt) => {
    var input = document.createElement('input');
    input.setAttribute('value', txt);
    document.body.appendChild(input);
    // 选择对象
    input.select();
    // 执行浏览器复制命令
    document.execCommand('copy');
    document.body.removeChild(input);
    Message.success(`‘${input.value}’复制成功`);
};

const YES_OR_NO = {
    '0': '否',
    '1': '是',
    'Y': '是',
    'N': '否'
};

/**
 * @description 处理基础信息列表数据
 */
export const formatBasicInfoList = (list, dictData) => {
    if (!Object.keys(list).length) return {};
    list.dispatchStatusName = dictData.DISPATCH_STATUS[list.dispatchStatus];
    list.procurementChannelName = dictData.OTP_TMS_PROCUREMENT_CHANNEL[list.procurementChannel];
    list.contractOutName = dictData.TMS_CONTRACT_SITUATION[list.contractOut];
    list.shippingTypeName = dictData.TMS_SHIPPING_TYPE[list.shippingType];
    list.convenientlyName = YES_OR_NO[list.conveniently] || ''; // 是否顺路带回
    list.payMethodName = dictData.SYS_TMS_PAY_METHOD[list.payMethod];
    list.transportTypeName = dictData.EC_TRANSPORT_TYPE[list.transportType] || '';
    list.dmsFlagName = YES_OR_NO[list.dmsFlag] || '';
    list.noCarPlatformFlagName = YES_OR_NO[list.noCarPlatformFlag] || '';
    list.noCarCarrierTypeName = dictData.NO_CAR_CARRIER_TYPE[list.noCarCarrierType] || '';
    list.bindingDeviceFlagName = +list.bindingDeviceFlag === 0 ? '已绑定' : '未绑定';
    list.deviceTypeName = dictData.DEVICETYPE[list.deviceType] || '';
    list.loadTypeName = dictData.NEW_TMS_LOAD_TYPE[list.loadType] || '';
    list.exceptionTypeName = dictData.EXCEPTION_TYPE[list.exceptionType] || '';
    list.isIflowName = list.isIflow === true ? '是' : '否';
    list.iflowStatusName = dictData.NEW_TMS_IFLOW_STATUS[list.iflowStatus] || '';
    list.businessIflowStatusName = dictData.NEW_TMS_IFLOW_STATUS[list.businessIflowStatus] || '';
    list.transportProtocolStatusName = dictData.TP_DISPATCH_STATUS[list.transportProtocolStatus] || '';
    list.createWayName = dictData.TP_DOCUMENTS_WAY[list.createWay] || '';
    list.lclStatusName = dictData.LCL_STATUS[list.lclStatus] || '';
    list.otpLdFlagName = list.otpLdFlag === 'Y' ? '是' : '否';
    list.onWayContactCategoryName = list.onWayContactCategory === '1' ? '司机' : (list.onWayContactCategory === '2' ? '供应商' : '');
    list.mileageBillingTypeName = dictData.MILEAGE_BILLING_TYPE[list.mileageBillingType] || '';
    list.billingRanksFlagName = dictData.BILLING_RANKS_FLAG[list.billingRanksFlag] || '';
    list.dispatchWayName = dictData.DISPATCH_WAY[list.dispatchWay + ''];
    list.billingCostAdvanceFlagName = list.billingCostAdvanceFlag === true ? '是' : (list.billingCostAdvanceFlag === false) ? '否' : '';
    list.billingAdvanceFlagName = list.billingAdvanceFlag === true ? '是' : (list.billingAdvanceFlag === false) ? '否' : '';
    list.orderTypeExtName = dictData.DISPATCH_EMERGENCE_FLAG[list.orderTypeExt + ''] || '';
    list.mileageBillingTypeName = dictData.MILEAGE_BILLING_TYPE[list.mileageBillingType] || '';
    list.isDriverSelfPrintName = list.isDriverSelfPrint === 'Y' ? '是' : '否';
    list.driverPrintTemplateName = dictData.SELF_PRINT_TEMPLATE[list.driverPrintTemplate] || '';
    list.driverPrintStatusName = dictData.DRIVER_PRINT_STATUS[list.driverPrintStatus] || '';
    list.inOutTypeName = dictData.OTP_IN_OUT_TYPE[list.inOutType] || '';
    list.shippingSceneTypeName = dictData.SHIPPING_SCENE_TYPE[list.shippingSceneType] || '';
    list.ztbTransportFlagName = YES_OR_NO[String(list.ztbTransportFlag)] || '';
    list.fenceDepartFlagName = YES_OR_NO[String(list.fenceDepartFlag)] || '';
    list.isAssociatedOrderName = YES_OR_NO[list.isAssociatedOrder] || '';
    list.directControlLineFlagName = YES_OR_NO[String(list.directControlLineFlag)] || '';
    list.directControlCarrierFlagName = YES_OR_NO[String(list.directControlCarrierFlag)] || '';
    list.twowayName = YES_OR_NO[list.twoway] || '';
    list.isRejectName = YES_OR_NO[list.isReject] || '';
    list.ztbUnissueReasonName = dictData.NOT_ISSUING_REASON[list.ztbUnissueReason] || '';
    list.departExceptionRemarksName = dictData.DISPATCH_ABNORMAL_REASON[list.departExceptionRemarks] || '';
    list.dispatchTypeName = dictData.TMS_DISPATCH_TYPE[list.dispatchType] || '';
    list.carrierVisibleFlagName = YES_OR_NO[list.carrierVisibleFlag] || '';
    return list;
};

export const formatLoadBookList = list => {
    if (!list.length) return [];
    list.forEach((item, index) => {
        item.tableIndex = index + 1;
        item.bookTypeName = item.bookType === '0' ? '装货预约' : (item.bookType === '1' ? '卸货预约' : '');
        item.urgentStatusName = item.urgentOpeTime === null ? '未加急' : (item.urgentType === '0' ? '已加急' : (item.urgentType === '2' ? '取消加急' : ''));
        item.reason = item.urgentFor ? `${item.urgentFor}(${item.urgentReason || '无'})` : '';
        Object.keys(item).forEach(key => {
            item[key] = (item[key] !== null && item[key] !== undefined && item[key] !== '') ? item[key] : '--';
        });
    });
    return list;
};

// 到车状态
const ARRIVALFLAG = {
    '0': '待处理',
    '1': '已处理'
};
/**
 * @description 处理装货站点列表数据
 */
export const formatLoadList = (list, dictData, inOutType) => {
    if (!list.length) return [];
    list.forEach((item, index) => {
        item.tableIndex = index + 1;
        item.arrivalRegistrationTypeName = dictData.PICK_UP_TYPE[item.arrivalRegistrationType];
        item.arrivalRegistrationStatus = ARRIVALFLAG[item.status];
        item.pickingProgress = inOutType === 'YS' ? '' : item.pickingProgress;
        item.loadingMethodName = dictData.TMS_LOADING_METHOD[item.loadingMethod] || '';
        Object.keys(item).forEach(key => {
            item[key] = (item[key] !== null && item[key] !== undefined && item[key] !== '') ? item[key] : '--';
        });
    });
    return list;
};
/**
 * @description 处理卸货站点列表数据
 */
export const formatUnloadList = (list, dictData) => {
    if (!list.length) return [];
    list.forEach((item, index) => {
        item.tableIndex = index + 1;
        item.arrivalConfirmTypeName = dictData.ARRIVER_WAY[item.arrivalConfirmType];
        item.arrivalStatus = ARRIVALFLAG[item.status];
        Object.keys(item).forEach(key => {
            item[key] = (item[key] !== null && item[key] !== undefined && item[key] !== '') ? item[key] : '--';
        });
    });
    return list;
};
/**
 * @description 处理任务信息列表数据
 */
const TASK_YES_OR_NO = {
    '0': '否',
    '1': '是'
};
export const formatTaskList = (list, dictData) => {
    if (!list.length) return [];
    list.forEach((item, index) => {
        item.tableIndex = index + 1;
        item.taskStatusName = dictData.TRANSPORT_STATUS[item.taskStatus];
        item.deliveryTypeName = dictData.DELIVERY_TYPE[item.deliveryType];
        item.businessTypeName = dictData.BUSINESS_TYPE[item.businessType];
        item.distributionFlagName = dictData.DISTRIBUTION_FLAG[item.distributionFlag];
        item.arrivalRegistrationTypeName = dictData.PICK_UP_TYPE[item.arriveType];
        item.arrivalConfirmTypeName = dictData.ARRIVER_WAY[item.arrivalWay];
        item.wmsStatusName = dictData.WMS_STATUS[item.wmsStatus];
        item.billingIncomeAdvanceFlagName = item.billingIncomeAdvanceFlag ? '是' : '否';
        item.pickUpStatusName = dictData.PICK_UP_STATUS[item.pickUpStatus];
        item.directControlFlagName = TASK_YES_OR_NO[item.directControlFlag] || '';
        item.orderTypeName = dictData.ORDER_TYPE[item.orderType] || '';
        item.taskTypeName = dictData.TASK_TYPE[item.taskType] || ''; // 任务类型
        item.businessModeName = dictData.BUSINESS_MODE[item.businessMode] || '';
        item.isSelectedRow = (item.actQty === null || item.actQty === undefined || item.actQty.age === '');
        Object.keys(item).forEach(key => {
            item[key] = (item[key] !== null && item[key] !== undefined && item[key] !== '') ? item[key] : '--';
        });
    });
    return list;
};

export const formatGoodsList = (list, dictData) => {
    if (!list.length) return [];
    list.forEach((item, index) => {
        item.tableIndex = index + 1;
        item.itemStatusName = dictData.O_ITEM_STATUS[item.itemStatus];
        item.taskStatusName = dictData.TRANSPORT_STATUS[item.taskStatus];
        item.deliveryTypeName = dictData.DELIVERY_TYPE[item.deliveryType];
        item.businessTypeName = dictData.BUSINESS_TYPE[item.businessType];
        item.distributionFlagName = dictData.DISTRIBUTION_FLAG[item.distributionFlag];
        item.arrivalRegistrationTypeName = dictData.PICK_UP_TYPE[item.arriveType];
        item.arrivalConfirmTypeName = dictData.ARRIVER_WAY[item.arrivalWay];
        item.wmsStatusName = dictData.WMS_STATUS[item.wmsStatus];
        item.billingIncomeAdvanceFlagName = item.billingIncomeAdvanceFlag ? '是' : '否';
        item.pickUpStatusName = dictData.PICK_UP_STATUS[item.pickUpStatus];
        item.orderTypeName = dictData.ORDER_TYPE[item.orderType] || '';
        item.taskTypeName = dictData.TASK_TYPE[item.taskType] || ''; // 任务类型
        item.businessModeName = dictData.BUSINESS_MODE[item.businessMode] || '';
        item.isSelectedRow = (item.actQty === null || item.actQty === undefined || item.actQty.age === '');
        Object.keys(item).forEach(key => {
            item[key] = (item[key] !== null && item[key] !== undefined && item[key] !== '') ? item[key] : '--';
        });
    });
    return list;
};

const OPERATE_TYPE = {
    'load': '装货',
    'unload': '卸货',
    'return': '返程'
};
export const formatDetailList = (data) => {
    if (!data.length) return;
    // 处理数据按装货、卸货、返程里程排列
    const loadList = data.filter(v => v.operateType === 'load');
    const unloadList = data.filter(v => v.operateType === 'unload');
    const returnList = data.filter(v => v.operateType === 'return'); // 返程里程
    const dataList = [...loadList, ...unloadList, ...returnList];
    dataList.forEach(item => {
        item.fourAddress = (item.provinceName ? `${item.provinceName}/` : '') + (item.cityName ? `${item.cityName}/` : '') + (item.districtName ? `${item.districtName}/` : '') + (item.townName || '');
        item.operateTypeName = OPERATE_TYPE[item.operateType] || '';
        item.loadSubsidyMileage = item.loadSubsidyMileage === undefined ? '-' : item.loadSubsidyMileage;
        item.unloadSubsidyMileage = item.unloadSubsidyMileage === undefined ? '-' : item.unloadSubsidyMileage;
        item.subsidyMileage = item.subsidyMileage === undefined ? '-' : item.subsidyMileage;
        // 多个仓库需去重后展示在同一个单元格
        item.warehouseNameList = new Set(item.lichengRecordDetails.map(v => v.warehouseName));
    });
    return dataList;
};
